import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--dropdown",
  "use": "icon-arrow--dropdown-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-arrow--dropdown\"><mask id=\"icon-arrow--dropdown_a\" fill=\"#fff\"><path d=\"m11.314 5.657-5.657 5.657L0 5.657 5.657 0l5.657 5.657Z\" /></mask><path d=\"m5.657 11.314-1.414 1.414 1.414 1.414 1.414-1.414-1.414-1.414ZM9.9 4.243 4.243 9.9l2.828 2.828 5.657-5.657L9.9 4.243ZM7.07 9.9 1.414 4.243-1.414 7.07l5.657 5.657L7.07 9.9Z\" fill=\"#111921\" mask=\"url(#icon-arrow--dropdown_a)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol